import React, { useState } from "react";

type Video = {
    url: string
    title: string,
    ratio: string
}

const videos:Video[] = [
    {
        url: 'https://www.loom.com/embed/c4a43216e6114eb3923f299b18d3f904?sid=3cd9a29e-3e56-45e8-812e-ed6362ef361f',
        title: 'Conectando o WhatsApp Business e Criando seu Público',
        ratio: '64.947%'
    },
    {
        url: 'https://www.loom.com/embed/ce44a6ae5205416ca7e10f05806944eb?sid=30c08596-dd99-4159-8786-580a2c8434d8',
        title: 'Criando e Enviando Campanhas no WhatsApp Business',
        ratio: '64.947%'
    },
    {
        url: "https://www.youtube.com/embed/xS4VownGnFo?si=0rYtoYZ1aD8Tsnsn",
        title: "Como se organizar usando as etiquetas no WhatsApp Business",
        ratio: "calc(9 / 16 * 100%)"
    }
]

function Video({video, onBack}:{video:Video, onBack:()=>void}){
    return <>
    <div className="d-flex align-items-center mb-3">
        <button className="btn btn-primary me-3" style={{borderRadius: '50%', width: '40px', height: '40px'}} onClick={onBack}>
            <i className="fa fa-arrow-left"></i>
        </button>
        <h4>{video.title}</h4>
    </div>
    
    <div className="ratio" style={{'--bs-aspect-ratio': video.ratio} as any}>
        <iframe className="rounded-3" src={video.url} frameBorder="0" allowFullScreen></iframe>
    </div></>
}


export function HelpModal(){
    const [video, setVideo] = useState<Video>(null);
    
    if(video)
        return <Video video={video} onBack={() => setVideo(null)} />

    return <>
        <h3>Tutoriais</h3>
        <ul>
            {videos.map(v => <li><a href="#" style={{textDecoration: "none"}} onClick={()=>setVideo(v)}>{v.title}</a></li>)}
        </ul>
    </>
}